
export const formatDateLabel = (value, intl, { hideYear = false } = {}) => {
  if (!value) return null;

  try {
    const parsed = value instanceof Date ? value : new Date(value);

    if (Number.isNaN(parsed.getTime())) {
      return value;
    }

    if (!intl || typeof intl.formatDate !== 'function') {
      const iso = parsed.toISOString();
      if (hideYear) {
        return iso.slice(5, 10);
      }
      return iso.slice(0, 10);
    }

    const formatOptions = hideYear
      ? {
          month: 'short',
          day: 'numeric',
        }
      : {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
        };

    return intl.formatDate(parsed, formatOptions);
  } catch (e) {
    return value;
  }
};

export const formatTimeLabel = (
  time: Date | string | null,
  intl: { formatTime: (date: Date, options?: object) => string },
): string | null => {
  if (!time) return null;

  try {
    const parsed = time instanceof Date ? time : new Date(`1970-01-01T${time}Z`);

    if (Number.isNaN(parsed.getTime())) {
      return time as string;
    }

    if (!intl || typeof intl.formatTime !== 'function') {
      return time as string;
    }

    return intl.formatTime(parsed, {
      timeZone: 'UTC',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch (e) {
    return time as string;
  }
};

export const formatTimeRangeLabel = (
  fromTime: Date | string | null,
  toTime: Date | string | null,
  intl: { formatTime: (date: Date, options?: object) => string },
): string | null => {
  const fromLabel = formatTimeLabel(fromTime, intl);
  const toLabel = formatTimeLabel(toTime, intl);

  if (fromLabel && toLabel) {
    return `${fromLabel} - ${toLabel}`;
  }

  if (fromLabel) {
    return fromLabel;
  }

  if (toLabel) {
    return toLabel;
  }

  return null;
};

export const formatDay = (day: number | null, short: boolean, intl: IntlShape): string | null => {
  if (day === null) return null;
  const date = new Date(2021, 0, 4 + day); // Jan 4, 2021 was a Monday
  return intl.formatDate(date, { weekday: short ? 'short' : 'long' });
};
